import { client } from "@/config/client"

export function cancelSubscription(userId: string) {
  return client.post(
    `/v1/users/admin/cancel-subscription/${userId}/7dd41063-1c36-442d-ba4a-e1eb48e33713`,
  )
}
